import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "epubexportpreference"
    }}>{`EPubExportPreference`}</h1>
    <p>{`EPub export preferences.`}</p>
    <h2 {...{
      "id": "instance"
    }}>{`Instance`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`level`}</strong>{` `}</p>
      <p parentName="blockquote">{`The PNG compression level.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`isValid`}</strong>{` `}</p>
      <p parentName="blockquote">{`Returns true if the object specifier resolves to valid objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`parent`}</strong>{` `}</p>
      <p parentName="blockquote">{`The parent of the EPubExportPreference (a Book or Document).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Events `}<strong parentName="p">{`events`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of events.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`EventListeners `}<strong parentName="p">{`eventListeners`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of event listeners.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`epubTitle`}</strong>{` `}</p>
      <p parentName="blockquote">{`The epub title.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`epubCreator`}</strong>{` `}</p>
      <p parentName="blockquote">{`The epub creator.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`epubSubject`}</strong>{` `}</p>
      <p parentName="blockquote">{`The epub subject.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`epubDescription`}</strong>{` `}</p>
      <p parentName="blockquote">{`The epub description.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`epubDate`}</strong>{` `}</p>
      <p parentName="blockquote">{`The epub date.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`epubRights`}</strong>{` `}</p>
      <p parentName="blockquote">{`The epub rights.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`useExistingImageOnExport`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, InDesign will use existing image for graphic objects on export.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`includeClassesInHTML`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, InDesign will generate class attributes for elements in HTML, else will generate plain html without class attributes.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`UseSVGAsEnum `}<strong parentName="p">{`useSVGAs`}</strong>{` `}</p>
      <p parentName="blockquote">{`Use SVG As`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`epubPublisher`}</strong>{` `}</p>
      <p parentName="blockquote">{`The epub publisher.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`id`}</strong>{` `}</p>
      <p parentName="blockquote">{`The epub unique identifier, like ISBN.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ExportOrder `}<strong parentName="p">{`exportOrder`}</strong>{` `}</p>
      <p parentName="blockquote">{`The export order.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`EpubCover `}<strong parentName="p">{`epubCover`}</strong>{` `}</p>
      <p parentName="blockquote">{`The epub cover option.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`coverImageFile`}</strong>{` `}</p>
      <p parentName="blockquote">{`The epub cover image file path.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`BulletListExportOption `}<strong parentName="p">{`bulletExportOption`}</strong>{` `}</p>
      <p parentName="blockquote">{`The bullet export option.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`NumberedListExportOption `}<strong parentName="p">{`numberedListExportOption`}</strong>{` `}</p>
      <p parentName="blockquote">{`The numbered list export option.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`leftMargin`}</strong>{` `}</p>
      <p parentName="blockquote">{`Left margin of the epub.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`rightMargin`}</strong>{` `}</p>
      <p parentName="blockquote">{`Right margin of the epub.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`topMargin`}</strong>{` `}</p>
      <p parentName="blockquote">{`Top margin of the epub.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`bottomMargin`}</strong>{` `}</p>
      <p parentName="blockquote">{`Bottom margin of the epub.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ImageResolution `}<strong parentName="p">{`imageExportResolution`}</strong>{` `}</p>
      <p parentName="blockquote">{`The export resolution`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ImageSizeOption `}<strong parentName="p">{`customImageSizeOption`}</strong>{` `}</p>
      <p parentName="blockquote">{`Allows user to select the image size option for conversion`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`preserveLayoutAppearence`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, format image based on layout appearence.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ImageAlignmentType `}<strong parentName="p">{`imageAlignment`}</strong>{` `}</p>
      <p parentName="blockquote">{`Alignment applied to images`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`imageSpaceBefore`}</strong>{` `}</p>
      <p parentName="blockquote">{`Space Before applied to images`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`imageSpaceAfter`}</strong>{` `}</p>
      <p parentName="blockquote">{`Space After applied to images`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`useImagePageBreak`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, image page break settings will be used in objects`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ImagePageBreakType `}<strong parentName="p">{`imagePageBreak`}</strong>{` `}</p>
      <p parentName="blockquote">{`Image page break settings to be used with objects`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ImageConversion `}<strong parentName="p">{`imageConversion`}</strong>{` `}</p>
      <p parentName="blockquote">{`The file format to use for converted images. Note: Valid only when copy optimized images and/or copy formatted images is true.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`GIFOptionsPalette `}<strong parentName="p">{`gifOptionsPalette`}</strong>{` `}</p>
      <p parentName="blockquote">{`The color palette for GIF conversion. Note: Not valid when image conversion is JPEG.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`gifOptionsInterlaced`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, generates interlaced GIFs. Note: Not valid  when image conversion is JPEG.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`JPEGOptionsQuality `}<strong parentName="p">{`jpegOptionsQuality`}</strong>{` `}</p>
      <p parentName="blockquote">{`The quality of converted JPEG images. Note: Not valid when image conversion is GIF.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`JPEGOptionsFormat `}<strong parentName="p">{`jpegOptionsFormat`}</strong>{` `}</p>
      <p parentName="blockquote">{`The formatting method for converted JPEG images. Note: Not valid  when image conversion is GIF.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`ignoreObjectConversionSettings`}</strong>{` `}</p>
      <p parentName="blockquote">{`ignore object level image conversion settings.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`tocStyleName`}</strong>{` `}</p>
      <p parentName="blockquote">{`The name of TOC style to generate epub TOC.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`breakDocument`}</strong>{` `}</p>
      <p parentName="blockquote">{`If  true, break InDesign document into smaller piece when generating epub.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`paragraphStyleName`}</strong>{` `}</p>
      <p parentName="blockquote">{`The name of paragraph style to break InDesign document.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`stripSoftReturn`}</strong>{` `}</p>
      <p parentName="blockquote">{`If  true, strip soft return.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`preserveLocalOverride`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, output local style override.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`embedFont`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, embed font in epub.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`externalStyleSheets`}</strong>{` `}</p>
      <p parentName="blockquote">{`The file path of external cascading style sheets.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`javascripts`}</strong>{` `}</p>
      <p parentName="blockquote">{`The file path of external javascripts.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`EpubVersion `}<strong parentName="p">{`version`}</strong>{` `}</p>
      <p parentName="blockquote">{`The version of EPUB.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`generateCascadeStyleSheet`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, InDesign will generate cascade style sheet.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`EPubFootnotePlacement `}<strong parentName="p">{`footnotePlacement`}</strong>{` `}</p>
      <p parentName="blockquote">{`The placement of footnote for EPub export`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Object `}<strong parentName="p">{`properties`}</strong>{` `}</p>
      <p parentName="blockquote">{`A property that allows setting of several properties at the same time.`}</p>
    </blockquote>
    <h3 {...{
      "id": "methods"
    }}>{`Methods`}</h3>
    <blockquote>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSource`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Generates a string which, if executed, will return the EPubExportPreference.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`EPubExportPreference `}<strong parentName="p">{`getElements`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Resolves the object specifier, creating an array of object references.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSpecifier`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Retrieves the object specifier.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`EventListener `}<strong parentName="p">{`addEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Adds an event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`removeEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Removes the event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-1"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      